import type { Offering } from '@highereducation/offerings';
import type { SponsoredCardProps } from '@highereducation/hen-ui';

/**
 * Maps an offerings-service `Offering` to the presentational
 * `SponsoredCardProps` expected by `hen-ui`.
 */
export function transformOfferingToSponsoredCardProps(
  offering: Offering,
): SponsoredCardProps {
  const org = offering.organization;

  return {
    sponsorLabel: 'Sponsored Partner',
    name: org.name,
    logoSrc: offering.imageUrl ?? '',
    logoAlt: `${org.name} logo`,
    visitHref: offering.destination?.url,
    visitLabel: 'Explore Program',
    sponsoredVisit: true,
    metaItems: buildMetaItems(offering),
    aboutHeading: `About ${org.name}`,
    children: offering.snippet || offering.shortDescription || undefined,
  };
}

function buildMetaItems(offering: Offering): string[] | undefined {
  const parts: string[] = [];
  const meta = offering.meta;

  if (meta?.degree?.name) parts.push(meta.degree.name);
  if (meta?.subject?.name) parts.push(meta.subject.name);
  if (offering.flexibility) parts.push(offering.flexibility);

  return parts.length > 0 ? parts : undefined;
}
